<template>
    <div class="popup">
        <div class="popup-content">
            <div class="x">
                <img
                    src="/img/close-btn.svg"
                    class="close-popup-btn"
                    @click="closePopup"
                />
            </div>
            <div class="popup-text">
                <div class="popup-title">
                    <i18n-t keypath="dashboard.declinePopup.title" />
                </div>
                <div class="popup-description">
                    <i18n-t keypath="dashboard.declinePopup.description" />
                </div>
            </div>
            <div class="message-container">
                <div class="message-label">
                    <span class="input-label-text-color">
                        <i18n-t keypath="dashboard.declinePopup.label.decline" />
                    </span>
                    <span class="input-label-symbol-color">*</span>
                </div>
                <div class="message-content">
                    <textarea
                        v-model="queryText"
                        class="message-textarea"
                        :placeholder="i18n.t('dashboard.declinePopup.textareaPlaceholder')"
                    ></textarea>
                </div>
            </div>
            <div class="button-container">
                <div>
                    <button class="button-text cancel-button" @click="closePopup">
                        <i18n-t keypath="dashboard.declinePopup.cancelButton" />
                    </button>
                </div>
                <div>
                    <button class="button-text decline-button" @click="confirm">
                        <i18n-t keypath="dashboard.declinePopup.declineButton" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    width: 440px;
    height: 337px;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
}

.close-popup-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.popup-text {
    text-align: center;
}

.popup-title {
    width: 313px;
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
}

.popup-description {
    width: 314px;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: rgba(98, 118, 144, 1);
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
}

.message-container {
    width: 380px;
    height: 88px;
    left: 495px;
    margin-bottom: 25px;
}

.message-label {
    width: 70px;
    height: 20px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
}

.message-content {
    width: 78px;
    height: 25px;
    top: 25px;
    opacity: 0.5px;
}

textarea::-webkit-scrollbar {
    width: 3px;
}

textarea::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

textarea::-webkit-scrollbar-thumb {
    background-color: rgba(26, 160, 225, 1);
    border-radius: 6px;
}

textarea::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(0deg, #627690, #627690);
}

.message-textarea {
    width: 380px;
    height: 88px;
    font-size: 15px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0;
    text-align: left;
    resize: none;
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none;
}

.input-label-text-color {
    background: linear-gradient(0deg, #627690, #627690);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.input-label-symbol-color {
    background: linear-gradient(0deg, #ff4545, #ff4545);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    border-top: 1px solid rgba(228, 234, 240, 1);
    padding-top: 10px;
    width: 110%;
    margin-left: -20px;
}

.button-container button {
    width: 150px;
    padding: 10px;
}

.button-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
    width: 116px;
    height: 40px;
}

.cancel-button {
    margin-left: 32px;
    color: rgba(26, 160, 225, 1);
    background: white;
    border-radius: 4px;
    border: 1px solid rgba(26, 160, 225, 1);
}

.decline-button {
    margin-right: 32px;
    color: white;
    background: rgba(255, 69, 69, 1);
    border: none;
    border-radius: 4px;
}

.cancel-button:hover,
.decline-button:hover {
    transform: scale(1.05);
}

.x {
}
</style>
<script lang="ts">
import { DeclinePopup } from "@/dashboard/my-orders/new-popup/decline-popup/decline-popup";

export default DeclinePopup;
</script>
